import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import Table from '../../../components/Table';
import { formatDate } from '../../../utils/formatDate';

const itemDefs = [
    {
        key: 'name',
        label: 'Name',
        value: 'name',
    },
    {
        key: 'size',
        label: 'Size',
        value: 'size',
    },
    {
        key: 'owner',
        label: 'Owner',
        value: 'owner',
    },
    {
        key: 'added',
        label: 'Added',
        itemContentRenderer: (item) => formatDate(item.dateAdded),
    },
    {
        key: 'modified',
        label: 'Last Modified',
        itemContentRenderer: (item) => formatDate(item.modified),
    },
];

const ImagesTable = ({ items, selectedItem, onSelect }) => (
    <Table
        primaryKey="name"
        items={items}
        itemDefinitions={itemDefs}
        selectedItem={selectedItem}
        onSelect={onSelect}
    />
);

ImagesTable.propTypes = {
    items: PropTypes.array,
    selectedItem: PropTypes.object,
    onSelect: PropTypes.func,
};

ImagesTable.defaultProps = {
    items: [],
    selectedItem: null,
    onSelect: noop,
};

export default ImagesTable;
